import React from "react";
import RemoteTable from "../../../components/ui/RemoteTable";
import { printFullDate } from "../../../utils/time";
import { printUnit } from "../../../utils/ar";
import { useLanguage } from "../../../context/LanguageContext";

const UserWalletRecords = () => {
    const { language } = useLanguage();

    const content = {
        columns: {
            sequence: { en: "Sequence", ar: "التسلسل", de: "Sequenz" },
            amountChanged: { en: "Amount Changed", ar: "المبلغ المتغير", de: "Geänderter Betrag" },
            balanceBefore: {
                en: "Balance Before Change",
                ar: "الرصيد قبل التغيير",
                de: "Saldo vor Änderung",
            },
            balanceAfter: {
                en: "Balance After Change",
                ar: "الرصيد بعد التغيير",
                de: "Saldo nach Änderung",
            },
            note: { en: "Note", ar: "ملحوظة", de: "Notiz" },
            creationTime: {
                en: "Record Creation Time",
                ar: "وقت انشاء الفاتورة",
                de: "Erstellungszeit",
            },
        },
        currency: { en: "EGP", ar: "جنيه", de: "EGP" }, // Keeping EGP consistent across languages
    };

    let columns = [
        {
            name: content.columns.sequence[language],
            reorder: true,
            selector: (row) => row.id,
            sortable: true,
            sortField: "id",
        },
        {
            name: content.columns.amountChanged[language],
            reorder: true,
            selector: (row) => printUnit(row.ammount_added, content.currency[language]),
            sortable: true,
            sortField: "ammount_added",
        },
        {
            name: content.columns.balanceBefore[language],
            reorder: true,
            selector: (row) => printUnit(row.previous_balance, content.currency[language]),
            sortable: true,
            sortField: "previous_balance",
        },
        {
            name: content.columns.balanceAfter[language],
            reorder: true,
            selector: (row) => printUnit(row.updated_balance, content.currency[language]),
            sortable: true,
            sortField: "updated_balance",
        },
        {
            name: content.columns.note[language],
            reorder: true,
            selector: (row) => row.comment,
            sortable: true,
            sortField: "comment",
        },
        {
            name: content.columns.creationTime[language],
            reorder: true,
            selector: (row) => printFullDate(row.created_at),
            sortable: true,
            sortField: "created_at",
        },
    ];

    return (
        <div>
            <div className="w-full">
                <RemoteTable
                    isAdmin={false}
                    api={`/api/user/wallet_records/paginate`}
                    columns={columns}
                />
            </div>
        </div>
    );
};

export default UserWalletRecords;
